export default "__VITE_ASSET__EtV0OCsU__"